/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Pro_6Inputs */



/**
* | output |
* | --- |
* | "Key Names and Phrases (KNP) Manager" |
*
* @param {Signup_Feature_Pro_6Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_pro_6 = /** @type {((inputs?: Signup_Feature_Pro_6Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Pro_6Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Key Names and Phrases (KNP) Manager")
	if (locale === "de") return /** @type {LocalizedString} */ ("Key Names and Phrases (KNP) Manager")
	if (locale === "it") return /** @type {LocalizedString} */ ("Key Names and Phrases (KNP) Manager")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Key Names and Phrases (KNP) Manager")
	if (locale === "es") return /** @type {LocalizedString} */ ("Key Names and Phrases (KNP) Manager")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Key Names and Phrases (KNP) Manager")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Key Names and Phrases (KNP) Manager")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Key Names and Phrases (KNP) Manager")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Key Names and Phrases (KNP) Manager")
	return /** @type {LocalizedString} */ ("Key Names and Phrases (KNP) Manager")
});